import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, bool_type, class_type, list_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_Lists_DokumentenDepot_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["List"];
    }
}

export function Page_$reflection() {
    return union_type("DokumentenDepot.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "DataLoaded", "GlobalMsg", "ChangeChecked", "CheckAll", "Auslagern", "AuslagernConfirmed", "Ausgelagert", "CloseDialoge"];
    }
}

export function Msg_$reflection() {
    return union_type("DokumentenDepot.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Dashboard_Lists_DokumentenDepot_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Dashboard_Lists_DokumentenDepot_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]], [["Item", class_type("System.Guid")]], [], [["Item", list_type(class_type("System.Guid"))]], [["Item", list_type(class_type("System.Guid"))]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], []]);
}

export class Model extends Record {
    constructor(Loading, Data, AllChecked, ShowAuslagernSuccessDialog, DokumenteZumAuslagern) {
        super();
        this.Loading = Loading;
        this.Data = Data;
        this.AllChecked = AllChecked;
        this.ShowAuslagernSuccessDialog = ShowAuslagernSuccessDialog;
        this.DokumenteZumAuslagern = DokumenteZumAuslagern;
    }
}

export function Model_$reflection() {
    return record_type("DokumentenDepot.Types.Model", [], Model, () => [["Loading", bool_type], ["Data", list_type(Dashboard_Lists_DokumentenDepot_$reflection())], ["AllChecked", bool_type], ["ShowAuslagernSuccessDialog", bool_type], ["DokumenteZumAuslagern", option_type(list_type(class_type("System.Guid")))]]);
}

//# sourceMappingURL=Types.fs.js.map
